export default __webpack_public_path__ + "bf0da70bd1706cc172bc4cac1f1d5168.png";